import {ButtonPackage} from './components/button/ButtonPackage'
import {TogglePackage} from './components/toggle/TogglePackage'
import {DropdownPackage} from './components/dropdown/DropdownPackage'
import {PaginationPackage} from './components/pagination/PaginationPackage'
import {TooltipPackage} from './components/tooltip/TooltipPackage'
import {DatetimeFieldEditorPackage} from './components/datetimefieldeditor/DatetimeFieldEditorPackage'
import {FieldEditorPackage} from './components/fieldeditor/FieldEditorPackage'
import {SelectPackage} from './components/select/SelectPackage'
import {AvatarPackage} from './components/avatar/AvatarPackage'
import {BylinePackage} from './components/byline/BylinePackage'
import {FormAddPackage} from './components/formadd/FormAddPackage'
import {FormSearchPackage} from './components/formsearch/FormSearchPackage'
import {InlineImagePackage} from './components/inlineimage/InlineImagePackage'
import {ImageCropperPackage} from './components/imagecropper/ImageCropperPackage'
import {DialogImagePackage} from './components/dialogimage/DialogImagePackage'

const registerUIPackages = function(configurator, packageList) {
    packageList.forEach((uiPackage) => {
        const packageName = uiPackage.name
        configurator.import(uiPackage)
        configurator.expose(packageName, configurator.getComponentRegistry().get(packageName))
    })
}

/**
 * Registers and exposes UI Components
 *
 * @type {{name: string, configure: UIPackage.configure}}
 */
const UIPackage = {
    name: 'UIPackage',
    configure: function(configurator) {

        registerUIPackages(configurator, [
            ButtonPackage,
            TogglePackage,
            DropdownPackage,
            PaginationPackage,
            TooltipPackage,
            DatetimeFieldEditorPackage,
            FieldEditorPackage,
            SelectPackage,
            AvatarPackage,
            BylinePackage,
            FormAddPackage,
            FormSearchPackage,
            InlineImagePackage,
            ImageCropperPackage,
            DialogImagePackage
        ])
    }
}

export {UIPackage}
